__turbopack_context__.v({
  "arrowButton": "imageCarousel-module-scss-module__eLuI5W__arrowButton",
  "arrowIcon": "imageCarousel-module-scss-module__eLuI5W__arrowIcon",
  "cardHeader": "imageCarousel-module-scss-module__eLuI5W__cardHeader",
  "cardSeparator": "imageCarousel-module-scss-module__eLuI5W__cardSeparator",
  "carousel": "imageCarousel-module-scss-module__eLuI5W__carousel",
  "carouselButtons": "imageCarousel-module-scss-module__eLuI5W__carouselButtons",
  "carouselContainer": "imageCarousel-module-scss-module__eLuI5W__carouselContainer",
  "carouselControls": "imageCarousel-module-scss-module__eLuI5W__carouselControls",
  "carouselDot": "imageCarousel-module-scss-module__eLuI5W__carouselDot",
  "carouselDotSelected": "imageCarousel-module-scss-module__eLuI5W__carouselDotSelected",
  "carouselDots": "imageCarousel-module-scss-module__eLuI5W__carouselDots",
  "carouselSlide": "imageCarousel-module-scss-module__eLuI5W__carouselSlide",
  "carouselViewport": "imageCarousel-module-scss-module__eLuI5W__carouselViewport",
  "error-msg": "imageCarousel-module-scss-module__eLuI5W__error-msg",
  "errorIcon": "imageCarousel-module-scss-module__eLuI5W__errorIcon",
  "hint": "imageCarousel-module-scss-module__eLuI5W__hint",
  "image": "imageCarousel-module-scss-module__eLuI5W__image",
  "imageCaption": "imageCarousel-module-scss-module__eLuI5W__imageCaption",
  "imageCaptionOnReport": "imageCarousel-module-scss-module__eLuI5W__imageCaptionOnReport",
  "imageContainer": "imageCarousel-module-scss-module__eLuI5W__imageContainer",
  "imageContainerOnReport": "imageCarousel-module-scss-module__eLuI5W__imageContainerOnReport",
  "imageOnReport": "imageCarousel-module-scss-module__eLuI5W__imageOnReport",
  "report": "imageCarousel-module-scss-module__eLuI5W__report",
  "summaryCardHeader": "imageCarousel-module-scss-module__eLuI5W__summaryCardHeader",
  "summaryCardTitle": "imageCarousel-module-scss-module__eLuI5W__summaryCardTitle",
});
